import * as Yup from 'yup';

export const SignInSchema = Yup.object().shape({
  email: Yup.string().email().required('Email is required'),
  password: Yup.string().min(8).required('Please provide your password'),
});

export type SignInDataType = Yup.InferType<typeof SignInSchema>;

type InitialValues = {
  email: string;
  password: string;
};

export const signinInitialValues: InitialValues = {
  email: '',
  password: '',
};

export interface IAdminUser {
  id: string;
  username: string;
  email: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

interface IToken {
  token: string;
}

export interface ISignInData {
  user: IAdminUser | null;
  accessToken: IToken;
  refreshToken: IToken;
}

export interface ILoginTokenResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
}

// While passkeys are required, a correct password returns this instead of
// tokens (docs/ops-and-account-acceptance-criteria.md D15). Keep the ticket in
// component state only: never Redux, localStorage or the URL.
export interface ISecondStepResponse {
  second_step: 'passkey' | 'enroll';
  ticket: string;
}

export interface IEnrolledResponse extends ILoginTokenResponse {
  recovery_codes: string[];
}
